import { createRouteRef } from '@backstage/frontend-plugin-api';

/**
 * The home page. Alone in its file, like `branchRouteRef`: the sidebar's
 * logo links to it without pulling the page's module in.
 */
export const homeRouteRef = createRouteRef();
